// noinspection DuplicatedCode

import React, { useEffect, useRef, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm, validate } from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// Nilai bawaan baris hasil scan. Activity dicari BERDASARKAN NAMA di master
// (bukan ID di-hardcode) supaya tidak diam-diam salah menunjuk kalau ID master
// berbeda antar server; kalau tak ketemu, Activity dibiarkan kosong.
const SCAN_DEFAULT_ACTIVITY_NAME = "TESTBACKEND";
const SCAN_DEFAULT_KETERANGAN = "Sesuai Permintaan User";

// Bunyi umpan balik scan. Dibangkitkan WebAudio — tanpa file audio, jadi tak ada
// aset eksternal yang perlu dimuat. Gagal membunyikan tak boleh mengganggu scan.
const beep = (ok) => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = "square";
    osc.frequency.value = ok ? 880 : 200;
    gain.gain.value = 0.05;
    osc.start();
    setTimeout(
      () => {
        try {
          osc.stop();
          ctx.close();
        } catch (e) {}
      },
      ok ? 90 : 260,
    );
  } catch (e) {}
};

const InsertPengeluaranBarangPage = ({}) => {
  let initialState = {
    BisnisUnitID: "U0002",
    Tanggal: new Date(),
  };

  let initialStateModal = {};

  // Validasi header. SEBELUMNYA daftar ini memeriksa UserPCName / KelompokID /
  // DetailAccountID — tiga field yang TIDAK ADA di form ini — sehingga tak ada
  // satu pun field header yang benar-benar dijaga, dan transaksi bisa tersimpan
  // tanpa Nama Peminta/Departemen.
  //
  // Catatan: isRequired() memanggil .trim(), jadi Tanggal (objek Date) TIDAK
  // boleh dilewatkan ke sana — akan melempar TypeError. Karena itu dicek sendiri.
  const validations = [
    ({ BisnisUnitID }) =>
      isRequired(BisnisUnitID) || { BisnisUnitID: "Bisnis Unit wajib diisi" },
    ({ Tanggal }) =>
      (Tanggal instanceof Date
        ? !isNaN(Tanggal.getTime())
        : isRequired(Tanggal)) || { Tanggal: "Tanggal wajib diisi" },
    ({ NamaPeminta }) =>
      isRequired(NamaPeminta) || { NamaPeminta: "Nama Peminta wajib diisi" },
    ({ Departement }) =>
      isRequired(Departement) || { Departement: "Departemen wajib diisi" },
    ({ Keterangan }) =>
      isRequired(Keterangan) || { Keterangan: "Keterangan wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    multiFieldHandler,
    changeHandler,
    errors,
    blastChange,
  } = useForm(initialState, validations);

  const barang = useMutation((formData) =>
    fetchGet("Procurement/GoodsStockMin"),
  );
  const activity = useMutation((formData) => fetchGet("Master/Activity/min"));
  // Dipakai untuk mengisi Departemen otomatis dari Bagian karyawan yang dipilih
  // di Nama Peminta. Isinya sama dgn yang di-fetch HrdInputGenerator (value =
  // NamaKaryawan), plus BagianID.
  const pemohon = useMutation(() => fetchGet("getKaryawanPemohon"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);
  const [barangData, setBarangData] = useState([]);
  const ModalOpener = (detail) => {
    setShowModal(true);
  };

  // ── Scan barcode ────────────────────────────────────────────
  // Scanner USB/Bluetooth bekerja seperti keyboard: mengetik kode lalu Enter.
  // Jadi yang dibutuhkan hanya satu input yang tetap terfokus.
  const scanInputRef = useRef(null);
  const [scanMode, setScanMode] = useState(true);
  const [scanValue, setScanValue] = useState("");
  // Hasil scan terakhir untuk umpan balik di layar: {ok, pesan, barangID}
  const [scanInfo, setScanInfo] = useState(null);

  // Kembalikan fokus ke kotak scan, TAPI jangan rebut fokus saat pengguna sedang
  // mengisi field lain (Bisnis Unit, Nama Peminta, dst) — itu bikin form tak
  // bisa diketik sama sekali.
  const keepScanFocus = () => {
    if (!scanMode) return;
    setTimeout(() => {
      const el = document.activeElement;
      const tag = (el?.tagName || "").toLowerCase();
      if (["input", "select", "textarea", "button"].includes(tag)) return;
      scanInputRef.current?.focus();
    }, 0);
  };

  useEffect(() => {
    if (scanMode) scanInputRef.current?.focus();
  }, [scanMode]);

  const tolakScan = (pesan) => {
    beep(false);
    setScanInfo({ ok: false, pesan });
    toast.error(pesan, { position: "top-center", autoClose: 3000 });
  };

  // Satu scan = SATU satuan barang, sesuai satuan yang tertempel labelnya.
  // Barcode yang sama di-scan lagi hanya menambah Qty baris yang sudah ada.
  const handleScan = (kodeMentah) => {
    const kode = (kodeMentah || "").trim();
    if (!kode) return;

    const found = barangData.find(
      (b) => (b.Barcode || "").trim() !== "" && (b.Barcode || "").trim() === kode,
    );
    if (!found) {
      tolakScan(`Barcode "${kode}" tidak dikenali. Barang belum punya barcode?`);
      return;
    }

    const saldoAkhir = parseFloat(found.SaldoAkhir || 0);
    const minQty = parseFloat(found.MinimalStock ?? found.MinQty ?? 0);
    const stokTersedia = Math.max(saldoAkhir - minQty, 0);
    const namaBarang = found.label || found.value;

    const idx = detail.findIndex((d) => d.BarangID === found.value);
    const qtySekarang = idx >= 0 ? parseFloat(detail[idx].QtyDiminta || 0) : 0;
    const qtyBaru = qtySekarang + 1;

    // Pagar stok sama dengan jalur manual: Stok Akhir adalah batas atas.
    if (qtyBaru > saldoAkhir) {
      tolakScan(
        `${namaBarang}: stok akhir hanya ${saldoAkhir}, tidak bisa menambah lagi.`,
      );
      return;
    }

    if (idx >= 0) {
      // Barang sudah ada di daftar → cukup tambah qty-nya.
      const baris = [...detail];
      baris[idx] = {
        ...baris[idx],
        QtyDiminta: qtyBaru,
        // Qty Keluar dibuat sama dgn Qty Diminta; penyesuaian dilakukan
        // saat approval.
        QtyKeluar: qtyBaru,
      };
      setDetail(baris);
    } else {
      const activityDefault = (activity.data?.data || []).find(
        (a) =>
          (a.ActivityName || a.label || "")
            .toString()
            .replace(/\s+/g, "")
            .toUpperCase() === SCAN_DEFAULT_ACTIVITY_NAME,
      );
      setDetail([
        ...detail,
        {
          BarangID: found.value,
          BarangName: namaBarang,
          NamaSatuan: found.NamaSatuan || "",
          SaldoAkhir: saldoAkhir,
          MinimalStock: minQty,
          MinQty: minQty,
          StokTersedia: stokTersedia,
          QtyDiminta: 1,
          QtyKeluar: 1,
          ActivityID:
            activityDefault?.ActivityID || activityDefault?.value || "",
          Keterangan: SCAN_DEFAULT_KETERANGAN,
        },
      ]);
    }

    beep(true);
    setScanInfo({
      ok: true,
      barangID: found.value,
      pesan: `${namaBarang} — qty ${qtyBaru}`,
    });
  };

  const onScanKeyDown = (e) => {
    // Scanner mengakhiri kode dengan Enter (setelan bawaan hampir semua alat).
    if (e.key !== "Enter") return;
    e.preventDefault();
    handleScan(scanValue);
    setScanValue("");
  };
  const param = useLocation();

  const mutation = useMutation((formData) =>
    fetchPost("Master/UserPC", formData),
  );
  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/GoodsExpenditure", formData),
  );
  const mutationGet = useMutation((formData) =>
    fetchGet("Procurement/GoodsExpenditure/" + formData),
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Procurement/GoodsExpenditure", formData),
  );

  const ModalEdit = (detail, id) => {
    setModalID(id);
    // Pastikan semua field yang diperlukan ada di modalDetail
    // Mapping dari MinQty (backend/table) ke MinimalStock (modal)
    setModalDetail({
      ...detail,
      MinimalStock: detail.MinimalStock !== undefined ? detail.MinimalStock : (detail.MinQty || 0),
      MinQty: detail.MinQty || detail.MinimalStock || 0, // Jaga-jaga
      SaldoAkhir: detail.SaldoAkhir || 0,
      StokTersedia: detail.StokTersedia || 0,
      QtyDiminta: detail.QtyDiminta || 0,
      QtyKeluar: detail.QtyKeluar || 0,
      ActivityID: detail.ActivityID || "",
      Keterangan: detail.Keterangan || "",
      BarangID: detail.BarangID || "",
    });
    console.log("ModalEdit - detail:", detail);
    console.log("ModalEdit - modalDetail:", {
      ...detail,
      MinimalStock: detail.MinimalStock !== undefined ? detail.MinimalStock : (detail.MinQty || 0),
    });
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    // Buat array BARU (bukan mutasi in-place): setDetail dgn referensi yang sama
    // tak memicu re-render — baris terhapus dari data tapi tetap tampil di layar,
    // lalu ikut hilang diam-diam saat simpan.
    const newDetail = detail.filter((_, i) => i !== id);
    setDetail(newDetail);
  };
  const params = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    barang.mutate();
    activity.mutate();
    pemohon.mutate();
    if (params.transid) {
      mutationGet.mutate(params.transid.replaceAll("-", "/"));
    }
    if (params.id) {
      customHandler(params.id, "BisnisUnitID");
    }
  }, []);

  // Saat Nama Peminta berganti: set NamaPeminta + isi Departemen dari Bagian
  // karyawan tsb DALAM SATU update. WAJIB multiFieldHandler, bukan dua kali
  // customHandler: customHandler membangun state dari `values` closure yang basi,
  // jadi panggilan kedua akan menimpa update pertama (NamaPeminta ikut hilang).
  // Departemen tetap boleh diubah manual setelahnya.
  const handlePemintaChange = (value, name) => {
    const found = pemohon.data?.data?.find((k) => k.value === value);
    const fields = { [name]: value };
    if (found && found.BagianID) {
      fields.Departement = found.BagianID;
    }
    multiFieldHandler(fields);
  };

  useEffect(() => {
    if (barang.data && barang.data.data) {
      setBarangData(barang.data.data);
    }
  }, [barang.data]);

  useEffect(() => {
    if (mutationUpdate) {
      if (mutationUpdate.isSuccess) {
        navigate("/gudang/transaction/pengeluaran-barang");
      }
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (mutationAdd) {
      if (mutationAdd.isSuccess) {
        navigate("/gudang/transaction/pengeluaran-barang");
      }
    }
  }, [mutationAdd.status]);

  useEffect(() => {
    if (mutationGet.data) {
      setDetail(mutationGet.data.data.Data);
      blastChange(mutationGet.data.data);
    }
  }, [mutationGet.status]);

  // const header = [
  //     {name: "Barang", key: "BarangID", modifiers: "Barang"},
  //     {name: "Satuan", key: "BarangID", modifiers: "BarangSatuan"},
  //     {name: "Qty Diminta", key: "QtyDiminta", modifiers: "number"},
  //     {name: "Qty Keluar", key: "QtyKeluar", modifiers: "number"},
  //     {name: "Activity", key: "ActivityID", modifiers: "Text"},
  //     {name: "Keterangan", key: "Keterangan", modifiers: "Text"},
  //     {name: "tools", key: "EditDelete", modifiers: "EditDelete"},
  // ]

  const header = [
    { name: "Barang", key: "BarangID", modifiers: "Barang" },
    { name: "Satuan", key: "BarangID", modifiers: "BarangSatuan" },
    { name: "Stok Akhir", key: "SaldoAkhir", modifiers: "number" },
    { name: "Minimal Stock", key: "MinQty", modifiers: "number" },
    { name: "Stok Tersedia", key: "StokTersedia", modifiers: "number" },
    { name: "Qty Diminta", key: "QtyDiminta", modifiers: "number" },
    { name: "Qty Keluar", key: "QtyKeluar", modifiers: "number" },
    { name: "Activity", key: "ActivityID", modifiers: "Activity" },
    { name: "Keterangan", key: "Keterangan", modifiers: "Text" },
    { name: "tools", key: "EditDelete", modifiers: "EditDelete" },
  ];

  const modalHandler = (value, names) => {
    // VALIDASI: TIDAK BOLEH NILAI MINUS UNTUK QTY
    if ((names === "QtyDiminta" || names === "QtyKeluar") && value < 0) {
      alert(`${names} tidak boleh bernilai minus!`);
      return;
    }
    
    // VALIDASI: TIDAK BOLEH NILAI MINUS UNTUK MINIMAL STOCK
    if (names === "MinimalStock" && value < 0) {
      alert("Minimal Stock tidak boleh bernilai minus!");
      return;
    }

    const newValues = { ...modalDetail, [names]: value };

    // JIKA YANG BERUBAH ADALAH BARANGID, CARI DATA STOK
    if (names === "BarangID" && value && barangData.length > 0) {
      const selectedBarang = barangData.find((item) => item.value === value);

      if (selectedBarang) {
        const saldoAkhir = parseFloat(selectedBarang.SaldoAkhir || 0);

        // backend kamu kirim MinQty
        const minQty = parseFloat(
          selectedBarang.MinimalStock ?? selectedBarang.MinQty ?? 0,
        );

        const stokTersedia = Math.max(saldoAkhir - minQty, 0);

        newValues.SaldoAkhir = saldoAkhir;
        newValues.MinimalStock = minQty; // untuk form
        newValues.MinQty = minQty; // untuk table
        newValues.StokTersedia = stokTersedia;
        newValues.BarangName = selectedBarang.label || "";

        // RESET QTY JIKA MELEBIHI STOK BARU
        if (parseFloat(newValues.QtyDiminta || 0) > stokTersedia) {
          newValues.QtyDiminta = 0;
        }

        if (parseFloat(newValues.QtyKeluar || 0) > stokTersedia) {
          newValues.QtyKeluar = 0;
        }
      }
    }
    
    // JIKA YANG BERUBAH ADALAH MINIMAL STOCK, HITUNG ULANG STOK TERSEDIA
    if (names === "MinimalStock") {
      const minimalStock = parseFloat(value) || 0;
      const saldoAkhir = parseFloat(newValues.SaldoAkhir || 0);
      const stokTersedia = Math.max(saldoAkhir - minimalStock, 0);
      
      newValues.MinQty = minimalStock; // untuk table
      newValues.StokTersedia = stokTersedia;
    }

    setModalDetail(newValues);
  };

  // const modalHandler = (value, names) => {
  //   const newValues = { ...modalDetail, [names]: value };

  //   // JIKA YANG BERUBAH ADALAH BARANGID, CARI DATA STOK
  //   if (names === "BarangID" && value && barangData.length > 0) {
  //     const selectedBarang = barangData.find((item) => item.value === value);
  //     if (selectedBarang) {
  //       newValues.SaldoAkhir = selectedBarang.SaldoAkhir || 0;
  //       newValues.MinimalStock = selectedBarang.MinimalStock || 0;
  //       newValues.StokTersedia = selectedBarang.StokTersedia || 0;
  //       newValues.BarangName = selectedBarang.label || "";
  //     }
  //   }

  //   setModalDetail(newValues);
  // };

  // const modalHandlerText = (event) => {
  //   const { name, value } = event.target;
  //   const newValues = {
  //     ...modalDetail,
  //     [name]: value,
  //   };

  //   // VALIDASI JIKA QTY KELUAR MELEBIHI STOK TERSEDIA
  //   if (name === "QtyKeluar") {
  //     const qtyKeluar = parseFloat(value) || 0;
  //     const stokTersedia = parseFloat(modalDetail.StokTersedia) || 0;

  //     if (qtyKeluar > stokTersedia) {
  //       alert("Qty Keluar tidak boleh melebihi Stok Tersedia!");
  //       return; // Jangan update state jika melebihi
  //     }
  //   }

  //   setModalDetail(newValues);
  // };

  const modalHandlerText = (event) => {
    const { name, value } = event.target;
    
    // VALIDASI: TIDAK BOLEH NILAI MINUS
    if (name === "QtyDiminta" || name === "QtyKeluar") {
      if (value.startsWith("-")) {
        alert(`${name} tidak boleh bernilai minus!`);
        return; // Jangan update state
      }
    }
    
    const newValues = {
      ...modalDetail,
      [name]: value,
    };

    // VALIDASI JIKA QTY DIMINTA ATAU QTY KELUAR MELEBIHI STOK AKHIR
    if (name === "QtyDiminta" || name === "QtyKeluar") {
      const qtyValue = parseFloat(value) || 0;
      const stokAkhir = parseFloat(modalDetail.SaldoAkhir) || 0;

      if (qtyValue > stokAkhir) {
        alert("Qty tidak boleh melebihi Stok Akhir!");
        return; // Jangan update state jika melebihi
      }
    }

    // VALIDASI TAMBAHAN: JIKA QTY KELUAR MELEBIHI STOK TERSEDIA
    // (StokTersedia = SaldoAkhir - MinQty; kebijakan stok minimum
    // ditegakkan sejak 2026-09-08, konsisten dgn guard backend)
    if (name === "QtyKeluar") {
      const qtyKeluar = parseFloat(value) || 0;
      const stokTersedia = parseFloat(modalDetail.StokTersedia) || 0;

      if (qtyKeluar > stokTersedia) {
        alert("Qty Keluar tidak boleh melebihi Stok Tersedia (Stok Akhir dikurangi Stok Minimum)!");
        return; // Jangan update state jika melebihi
      }
    }

    setModalDetail(newValues);
  };

  const inputBuilder = [
    // {
    //     type: "BarangGoods",
    //     name: "BarangID",
    //     title: "Barang",
    //     handler: modalHandler,
    //     size: "full",
    //     required: false,
    //     disabled: false,
    //     edit: false
    // },
    // {
    //     type: "number",
    //     name: "QtyDiminta",
    //     title: "Stock Barang",
    //     handler: modalHandlerText,
    //     size: "full",
    //     required: false,
    //     disabled: false,
    //     edit: false
    // },
    // {
    //     type: "number",
    //     name: "QtyKeluar",
    //     title: "Qty Keluar",
    //     handler: modalHandlerText,
    //     size: "full",
    //     required: false,
    //     disabled: false,
    //     edit: false
    // },

    {
      type: "BarangGoods",
      name: "BarangID",
      title: "Barang",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "number",
      name: "SaldoAkhir",
      title: "Stok Akhir",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "number",
      name: "MinimalStock",
      title: "Minimal Stock",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,  // Bisa diedit
      edit: true,       // Muncul saat edit mode
    },
    {
      type: "number",
      name: "StokTersedia",
      title: "Stok Tersedia",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: true,
      edit: false,
    },
    {
      type: "number",
      name: "QtyDiminta",
      title: "Qty Diminta",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "number",
      name: "QtyKeluar",
      title: "Qty Keluar",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "activity",
      name: "ActivityID",
      title: "Activity",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text",
      name: "Keterangan",
      title: "Keterangan",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
  ];

  // const Kirim = () => {
  //   let newValues = values;
  //   try {
  //     newValues["Tanggal"] = newValues["Tanggal"].toISOString();
  //   } catch (err) {}
  //   let details = detail;
  //   for (let i = 0; i < detail.length; i++) {
  //     details[i]["QtyDiminta"] = parseInt(details[i]["QtyDiminta"]);
  //     details[i]["QtyKeluar"] = parseInt(details[i]["QtyKeluar"]);
  //   }
  //   newValues["Status"] = "1";
  //   newValues["Data"] = details;
  //   if (params.transid) {
  //     mutationUpdate.mutate(newValues);
  //   } else {
  //     mutationAdd.mutate(newValues);
  //   }
  // };

  const Kirim = () => {
    setButtonTouched(true);

    // Hitung ulang validasi dari `values` saat ini, JANGAN pakai `isValid` dari
    // useForm: blastChange() (dipakai saat memuat transaksi lama untuk diedit)
    // hanya setValues tanpa memvalidasi ulang, jadi isValid-nya basi dan mode
    // edit akan terblokir padahal datanya lengkap.
    const { isValid: headerValid, errors: headerErrors } = validate(
      validations,
      values,
    );
    if (!headerValid) {
      toast.warn(`Lengkapi dulu: ${Object.values(headerErrors).join(", ")}`, {
        position: "top-center",
        autoClose: 4000,
      });
      return;
    }

    if (detail.length === 0) {
      toast.warn("Belum ada barang. Scan barcode atau tambah barang dulu.", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    for (let i = 0; i < detail.length; i++) {
      const item = detail[i];
      const nama = item.BarangName || item.BarangID || `baris ${i + 1}`;
      if (!item.BarangID) {
        toast.warn(`Baris ${i + 1}: barang belum dipilih.`, {
          position: "top-center",
          autoClose: 3000,
        });
        return;
      }
      if (!(parseFloat(item.QtyDiminta) > 0)) {
        toast.warn(`${nama}: Qty Diminta harus lebih dari 0.`, {
          position: "top-center",
          autoClose: 3000,
        });
        return;
      }
    }

    // VALIDASI FINAL SEBELUM KIRIM DATA
    for (let i = 0; i < detail.length; i++) {
      const item = detail[i];
      const qtyDiminta = parseFloat(item.QtyDiminta || 0);
      const qtyKeluar = parseFloat(item.QtyKeluar || 0);
      const stokAkhir = parseFloat(item.SaldoAkhir || 0);
      const stokTersedia = parseFloat(item.StokTersedia || 0);

      if (qtyDiminta > stokAkhir) {
        alert(
          `Barang ${
            item.BarangName || item.BarangID
          }: Qty Diminta (${qtyDiminta}) melebihi Stok Akhir (${stokAkhir})!`,
        );
        return;
      }

      if (qtyKeluar > stokAkhir) {
        alert(
          `Barang ${
            item.BarangName || item.BarangID
          }: Qty Keluar (${qtyKeluar}) melebihi Stok Akhir (${stokAkhir})!`,
        );
        return;
      }

      if (qtyKeluar > stokTersedia) {
        alert(
          `Barang ${
            item.BarangName || item.BarangID
          }: Qty Keluar (${qtyKeluar}) melebihi Stok Tersedia (${stokTersedia})!`,
        );
        return;
      }
    }

    let newValues = values;
    try {
      newValues["Tanggal"] = newValues["Tanggal"].toISOString();
    } catch (err) {}

    let details = detail.map((item) => ({
      ...item,
      QtyDiminta: parseFloat(item["QtyDiminta"]),
      QtyKeluar: parseFloat(item["QtyKeluar"]),
    }));

    newValues["Status"] = "1";
    newValues["Data"] = details;

    if (params.transid) {
      mutationUpdate.mutate(newValues);
    } else {
      mutationAdd.mutate(newValues);
    }
  };
  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() =>
                      navigate("/gudang/transaction/pengeluaran-barang")
                    }
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  <button
                    onClick={() => Kirim()}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="current
                                       Color"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Simpan"
                    )}
                  </button>
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"BisnisUnit"}
                    value={values}
                    name={"BisnisUnitID"}
                    title={"Bisnis Unit"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"dateOnly"}
                    value={values}
                    name={"Tanggal"}
                    title={"Tanggal"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"KaryawanPemohon"}
                    value={values}
                    name={"NamaPeminta"}
                    title={"Nama Peminta"}
                    onChange={handlePemintaChange}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"Bagian"}
                    value={values}
                    name={"Departement"}
                    title={"Departemen"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"Keterangan"}
                    title={"Keterangan"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>

                <hr />

                {/* ── Panel scan barcode ──────────────────────────────
                    Barang boleh dimasukkan lewat scan ATAU lewat tombol
                    Tambah di tabel (cari data) — keduanya menghasilkan
                    baris yang sama persis. */}
                <div className="mx-4 my-4 rounded-lg border border-main-100 bg-blue-50 p-4">
                  <div className="flex flex-col gap-3 md:flex-row md:items-end">
                    <div className="flex-1">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                        Scan Barcode
                      </label>
                      <input
                        ref={scanInputRef}
                        type="text"
                        value={scanValue}
                        onChange={(e) => setScanValue(e.target.value)}
                        onKeyDown={onScanKeyDown}
                        onBlur={keepScanFocus}
                        disabled={!scanMode}
                        placeholder="Arahkan scanner ke sini, atau ketik kode lalu Enter"
                        className="appearance-none block w-full text-gray-700 border border-gray-500 rounded-lg py-3 px-4 leading-tight outline-none bg-white font-mono disabled:bg-gray-100"
                      />
                    </div>

                    <div className="flex items-center gap-2 pb-3">
                      <input
                        id="scanMode"
                        type="checkbox"
                        checked={scanMode}
                        onChange={(e) => setScanMode(e.target.checked)}
                        className="h-4 w-4"
                      />
                      <label htmlFor="scanMode" className="text-sm text-gray-700">
                        Mode scan aktif
                      </label>
                    </div>
                  </div>

                  <div className="mt-2 text-xs">
                    {scanInfo ? (
                      <span
                        className={
                          scanInfo.ok
                            ? "font-medium text-green-700"
                            : "font-medium text-red-600"
                        }
                      >
                        {scanInfo.ok ? "✓ " : "✕ "}
                        {scanInfo.pesan}
                      </span>
                    ) : (
                      <span className="text-gray-500">
                        Satu scan = 1 satuan. Barcode yang sama di-scan lagi
                        menambah qty barang yang sudah ada di daftar.
                      </span>
                    )}
                  </div>
                </div>

                <DynamicTableSimple
                  data={detail}
                  header={header}
                  Master={true}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                  activity={activity.data}
                  edit={ModalEdit}
                  delete={ModalDelete}
                />
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                }}
              >
                {showModalEdit ? "Edit Data" : "Tambah Data"}
              </ModalHeader>
              <ModalBody>
                <form className="w-full " onSubmit={submitHandler}>
                  {inputBuilder.map(
                    (
                      {
                        type,
                        name,
                        title,
                        handler,
                        modifiers,
                        size,
                        required,
                        disabled,
                        edit,
                      },
                      index,
                    ) => {
                      if (!edit || showModalEdit) {
                        return (
                          <HrdInputGenerator
                            key={`input-${name}-${index}`} // TAMBAHKAN KEY PROP
                            type={type}
                            value={modalDetail}
                            name={name}
                            title={title}
                            onChange={handler}
                            touched={touched}
                            buttonTouched={buttonTouched}
                            modifiers={modifiers}
                            size={size}
                            required={required}
                            errors={errors}
                            disabled={disabled}
                          />
                        );
                      }
                      return null; // PENTING: RETURN NULL UNTUK KONSISTENSI
                    },
                  )}
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                {/* <Button
                  color={isValid || !isValid ? "green" : "blueGray"}
                  disabled={mutation.isLoading}
                  onClick={() => {
                    if (!isValid && changed) {
                      setButtonTouched(true);
                    }
                    let tempIsValid = isValid;
                    if (!isValid) {
                    }
                    if (showModalEdit) {
                      const newValues = [...detail];
                      newValues[modalID] = modalDetail;
                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                      setShowModal(false);
                      setShowModalEdit(false);
                    } else {
                      const newValues = [...detail, modalDetail];
                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                    }
                  }}
                  ripple={isValid ? "light" : ""}
                >
                  {showModalEdit ? "Ubah" : "Tambah"}
                </Button> */}

                <Button
                  color={isValid || !isValid ? "green" : "blueGray"}
                  disabled={mutation.isLoading}
                  onClick={() => {
                    // VALIDASI FINAL SEBELUM MENAMBAH DATA
                    const qtyDiminta = parseFloat(modalDetail.QtyDiminta || 0);
                    const qtyKeluar = parseFloat(modalDetail.QtyKeluar || 0);
                    const stokAkhir = parseFloat(modalDetail.SaldoAkhir || 0);
                    const stokTersedia = parseFloat(
                      modalDetail.StokTersedia || 0,
                    );

                    if (qtyDiminta > stokAkhir) {
                      alert("Qty Diminta tidak boleh melebihi Stok Akhir!");
                      return;
                    }

                    if (qtyKeluar > stokAkhir) {
                      alert("Qty Keluar tidak boleh melebihi Stok Akhir!");
                      return;
                    }

                    if (qtyKeluar > stokTersedia) {
                      alert("Qty Keluar tidak boleh melebihi Stok Tersedia!");
                      return;
                    }

                    if (!isValid && changed) {
                      setButtonTouched(true);
                    }

                    let tempIsValid = isValid;
                    if (!isValid) {
                      // Handle validation error
                    }

                    if (showModalEdit) {
                      const newValues = [...detail];
                      newValues[modalID] = modalDetail;
                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                      setShowModal(false);
                      setShowModalEdit(false);
                    } else {
                      const newValues = [...detail, modalDetail];
                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                    }
                  }}
                  ripple={isValid ? "light" : ""}
                >
                  {showModalEdit ? "Ubah" : "Tambah"}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertPengeluaranBarangPage;
